import type { TGetErrorFn, TSelectedCategories } from './models';

export const validateCashbackCategories = (
    requiredCount: number,
    selectedCategories: TSelectedCategories
) => {
    if (selectedCategories?.length < requiredCount && selectedCategories?.length !== 0) {
        return true;
    }
};

export const getErrorMobile: TGetErrorFn = ({ error, meta }) => {
    const isSetError = (meta.dirty && meta.error) ?? meta.submitError;

    return isSetError ? error : undefined;
};

export const getErrorDesktop: TGetErrorFn = ({ error, isDropdownOpen, meta }) => {
    if (isDropdownOpen) return undefined;

    const isSetError = (meta.dirty && meta.error) ?? meta.submitError;

    return isSetError ? error : undefined;
};

export const getCurrentMonth = () => {
    return new Date().toLocaleString('ru', { month: 'long' });
};
